<script setup lang="ts">
export interface PagebuilderSwitchProps {
    data: {
        switch_left_name: string
        switch_left_url: string
        switch_right_name: string
        switch_right_url: string
        switch_top_position: boolean
    }
}

const props = defineProps<PagebuilderSwitchProps>()

const route = useRoute()

const items = computed(() => [
    { name: props.data.switch_left_name, url: props.data.switch_left_url },
    { name: props.data.switch_right_name, url: props.data.switch_right_url },
])
</script>

<template>
  <div class="d-flex justify-content-center gap-3">
    <div class="p-1 bg-gray-1 rounded d-flex">
      <VNuxtLink
        v-for="(item, index) in items"
        :key="`switch-${index}`"
        :to="item.url"
        class="h-100 d-flex align-items-center px-3 py-1 rounded fw-bold text-decoration-none fs-small fs-sm-normal"
        :class="{'bg-secondary text-white': route.path === item.url, 'text-black': route.path !== item.url}"
      >
        {{ item.name }}
      </VNuxtLink>
    </div>
  </div>
</template>
